import ProductPanel, { type NavProductProps } from './product-panel'
import StandardPanel, { type NavItem } from './standard-panel'
import { PromoProps } from './components/promo'

export { ProductPanel, StandardPanel }
export type { NavProductProps, PromoProps, NavItem }
